import { render } from "./merchantManagement.vue?vue&type=template&id=6dcefc12"
import script from "./merchantManagement.vue?vue&type=script&lang=js"
export * from "./merchantManagement.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__